"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CIRCUIT_CONFIG = void 0;
exports.DEFAULT_CIRCUIT_CONFIG = Object.freeze({
    k: 14,
    numAdvice: 4,
    numLookupAdvice: 1,
    numInstance: 1,
    numLookupBits: 13,
    numVirtualInstance: 1,
});
